import { FC, useState } from 'react'

import { Stack, TextField, Typography } from '@forto-dev/phoenix-ui-core'

import { SurveyQuestionProps, SurveyQuestionStatus } from '../domain/survey/surveyQuestionProps'
import { useRenderSurveyText } from '../hooks/survey/useRenderSurveyText'

export const FreeTextSurveyQuestion: FC<SurveyQuestionProps> = ({ question, onChange }) => {
  const { render } = useRenderSurveyText()
  const [value, setValue] = useState('')

  return (
    <Stack gap={8}>
      <Typography variant="body">{render(question)}</Typography>
      {question.responses.map((response) => (
        <TextField
          key={response.id}
          value={value}
          onChange={(event) => {
            setValue(event.target.value)
            onChange({
              surveyQuestionResponse: {
                id: question.id,
                // NOTE: this doesn't currently support multiple freeText responses fully
                responses: [{ id: response.id, comment: event.target.value }],
              },
              status: event.target.value ? SurveyQuestionStatus.answered : SurveyQuestionStatus.unanswered,
            })
          }}
          placeholder={render(response)}
        />
      ))}
    </Stack>
  )
}
